import React from 'react';
import { People } from 'components/people/People';
import { PeopleItem } from 'components/people/PeopleItem';

export const Component = () => {
  return (
    <People
      tagline="Tagline"
      title="People"
      text={
        <p>
          Alvogen’s leadership team is dedicated to fostering a dynamic change-driven culture
          committed to meeting the needs of our customers. Our organizational structure is lean and
          flexible, driving quick and effective decision making and thus enabling the company to
          bring new generic products quickly and safely to market.The executive leadership team
          forms the Alvogen Management Board.
        </p>
      }
      isSlice
    >
      {new Array(15).fill(null).map((_, key) => (
        <PeopleItem
          key={key}
          name="Person name"
          position="Position"
          image={{ url: 'https://picsum.photos/id/983/400/520', width: 400, height: 520 }}
        />
      ))}
    </People>
  );
};
